module.exports = __webpack_public_path__ + "static/media/Glazbeno-scenki prikaz-foto 3.748f2470.png";